module.exports = __webpack_public_path__ + "img/head-phone-read-aloud-dark.baad1aa.svg";